/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'prescription-active-past': {
    width: 40,
    height: 40,
    viewBox: '0 0 40 40',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M7 11.667c0-2.42 2.01-4.334 4.429-4.334H14a1 1 0 110 2h-2.571C10.06 9.333 9 10.404 9 11.667v20C9 32.929 10.06 34 11.429 34H28.57C29.94 34 31 32.929 31 31.667v-20c0-1.263-1.06-2.334-2.429-2.334h-3.428a1 1 0 110-2h3.428c2.42 0 4.429 1.914 4.429 4.334v20C33 34.087 30.99 36 28.571 36H11.43C9.009 36 7 34.086 7 31.667v-20z" _fill="#1F222C"/><path pid="1" fill-rule="evenodd" clip-rule="evenodd" d="M14 7a3 3 0 013-3h6a3 3 0 013 3v2.667a3 3 0 01-3 3h-6a3 3 0 01-3-3V7zm3-1a1 1 0 00-1 1v2.667a1 1 0 001 1h6a1 1 0 001-1V7a1 1 0 00-1-1h-6zM24.664 19.253a1 1 0 01.083 1.411l-5.333 6a1 1 0 01-1.495 0l-2.666-3a1 1 0 011.494-1.328l1.92 2.159 4.586-5.16a1 1 0 011.411-.082z" _fill="#1F222C"/>'
  }
})
